<template>
	<div class="flex flex-row gap-2 items-center justify-between">
		<I2Label ref="i2LabelRef" size="h1" :label="labelText" :helpElementName="helpPageName">
			<slot></slot>
		</I2Label>
		<slot name="rightSide"></slot>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUpdated } from "vue"
import I2Label from "@/crispify/crispy-components/I2Label.vue"

defineProps({
	helpPageName: {
		type: String,
		required: true,
	},
})

const i2LabelRef = ref<InstanceType<typeof I2Label> | null>(null)
const labelText = ref<string>("")

function updateLabelText() {
	labelText.value = i2LabelRef.value?.$el?.innerText?.trim() ?? ""
}

onMounted(updateLabelText)
onUpdated(updateLabelText)
</script>

<style scoped></style>
